export const EMPTY_ARR = []
export const EMPTY_OBJ = {}
export const ZERO = 0
export const EMPTY_STRING = ''
